module.exports = __webpack_public_path__ + "static/media/mobile.8ffe20f7.png";